import {
  DialogFocusTrapTest,
  DryMassEntryGridSectionTest,
  DryMassEntryListSectionTest,
  InterfacingTest,
  NestedCSSTest,
  TestWorksheetInjectedPropsProvider,
} from 'Components/Test';
import { DryMassEntryTestConfig } from 'Components/Test/DryMassEntry/config';
import { TestPagesState } from 'Data/ReduxViewModels/TestPages/types';
import { joinPaths } from 'Lib/Object/Path/shared';

type TestPageConfig = {
  [componentId: string]: {
    linkText: string;
    component: React.FC;
    config?: TestPagesState['config'];
    initialData?: any;
    propsProvider?: typeof TestWorksheetInjectedPropsProvider;
  };
};

const testPageConfig: TestPageConfig = {
  interfacing: {
    linkText: 'Interfacing',
    component: InterfacingTest,
  },
  dryMassEntryList: {
    linkText: 'Dry Mass Entry - List Section',
    component: DryMassEntryListSectionTest,
    config: DryMassEntryTestConfig,
    propsProvider: TestWorksheetInjectedPropsProvider,
    initialData: {
      DryMassReadings: [{}],
    },
  },
  dryMassEntryGrid: {
    linkText: 'Dry Mass Entry - Grid',
    component: DryMassEntryGridSectionTest,
    config: Object.fromEntries(
      Object.entries(DryMassEntryTestConfig).map(([k, v]) => [joinPaths('MoistureDeterminations', k), v])
    ),
    propsProvider: TestWorksheetInjectedPropsProvider,
    initialData: {
      MoistureDeterminations: [{ DryMassReadings: [{}] }],
    },
  },
  dialogFocusTrap: {
    linkText: 'Dialog Focus Trap',
    component: DialogFocusTrapTest,
  },
  nestedCSSPerformance: {
    linkText: 'Nested CSS Performance',
    component: NestedCSSTest,
  },
};

export default testPageConfig;
